import { Directive,HostListener,Input } from '@angular/core';
import { Globals } from '../_models/globals';
import { UserService } from 'app/_services/user.service';

declare var gtag: Function; // Declara a função global do Google Analytics

@Directive({
    selector: '[eventTracker]',
    standalone: false
})
export class AnalyticsDirective {
  @Input('eventTracker') option: {event_category: string, [key: string]: string };

  @HostListener('click', ['$event']) onClick($event){
    const user = this.userService.user();

    const isRepairer = [1, 2, 64].includes(user.role);
    const plan = user.plan === 1
        ? this.globals.translate('geral.info-geral.planos.popular')
        : (user.plan === 2
            ? this.globals.translate('geral.info-geral.planos.V8')
            : (isRepairer ? this.globals.translate('geral.info-geral.planos.central') : this.globals.translate('geral.info-geral.planos.turbo'))
        );

    gtag('event', this.option.event_category, {
        'user_name': user.firstName,
        'user_email': user.email,
        'user_current_company_name': user.current_company_name,
        'user_type': isRepairer ? this.globals.translate('geral.info-geral.oficina') : this.globals.translate('geral.info-geral.fornecedor'),
        'user_plan': plan,
        ...this.option
    });
  }

  constructor(protected userService: UserService , private globals: Globals) { }
}
